export default __webpack_public_path__ + "static/media/17.54b8c501.webp";